import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../Components/utils/getToken";

function authHeaders() {
  const token = decryptToken("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function fetchPermissionsCatalog() {
  const res = await fetch(`${API_BASE_URL}/api/rbac/permissions/catalog`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load permissions");
  return data.data;
}

export async function fetchPermissionsGrouped() {
  const res = await fetch(`${API_BASE_URL}/api/rbac/permissions`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load permissions");
  return data.data;
}

export async function fetchRoleTemplates() {
  const res = await fetch(`${API_BASE_URL}/api/rbac/roles?templates=1`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load templates");
  return data.data;
}

export async function fetchStaffPermissions(staffId) {
  const res = await fetch(`${API_BASE_URL}/api/rbac/staff/${staffId}/permissions`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load staff permissions");
  return data.data;
}

export async function updateStaffPermissions(staffId, payload) {
  const res = await fetch(`${API_BASE_URL}/api/rbac/staff/${staffId}/permissions`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to update permissions");
  return data.data;
}

export async function cloneStaffPermissions(staffId, sourceStaffId) {
  const res = await fetch(`${API_BASE_URL}/api/rbac/staff/${staffId}/permissions/clone`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ sourceStaffId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to clone permissions");
  return data.data;
}

export async function createPermissionTemplate(payload) {
  const res = await fetch(`${API_BASE_URL}/api/rbac/roles/templates`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to create template");
  return data.data;
}

export async function updatePermissionTemplate(roleId, payload) {
  const res = await fetch(`${API_BASE_URL}/api/rbac/roles/templates/${roleId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to update template");
  return data.data;
}

export async function deletePermissionTemplate(roleId) {
  const res = await fetch(`${API_BASE_URL}/api/rbac/roles/templates/${roleId}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to delete template");
  return data;
}

export async function fetchStaffListForClone() {
  const res = await fetch(`${API_BASE_URL}/staff`, {
    headers: authHeaders(),
  });
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : data?.data || [];
}
